const module = { name: 'Fandango/clearableInput', exports: {} }; const exports = module.exports;



const Selectors = {
    AUTO_ATTACH_INPUTS: '.js-clearable-input',
    CLEAR_BTN: '[type="button"]',
    INPUT: 'input:not([type="button"])',
}


const Styles = {
    HAS_VALUE: 'fd-clearable-input--has-value',
}


const Attribs = {
    TAB: 'tabindex',
}


const DataAttribs = {
    MODAL: 'isModal',
    READY: 'clearableEnabled',
}


const EventNames = {
    CLEARED: 'fd.clearable.clear',
}
function updateState(parentElem, hasValue) {
    hasValue = Boolean(hasValue);
    const priorState = parentElem.classList.contains(Styles.HAS_VALUE);
    if (priorState === hasValue) {
        return;
    }
    parentElem.classList.toggle(Styles.HAS_VALUE, hasValue);
    const btn = parentElem.querySelector(Selectors.CLEAR_BTN);
    if (btn && parentElem.dataset[DataAttribs.MODAL] === 'true') {
        btn.setAttribute(Attribs.TAB, hasValue ? 1 : -1);
    }
}
function onClearClick(e) {
    e.preventDefault();
    const input = e.target.parentElement.querySelector(Selectors.INPUT);
    input.value = '';
    input.focus();
    updateState(input.parentElement, false);
    input.dispatchEvent(new Event(EventNames.CLEARED));
}
function onKeyUp(e) {
    updateState(e.target.parentElement, e.target.value.length);
}
function addClearBtn(parentElem, labelText, input) {
    const btn = document.createElement('input');
    btn.type = 'button';
    btn.classList.add('fd-clearable-input__icon', 'icon', 'icon-form-input-cancel-x');
    btn.setAttribute('role', 'button');
    btn.innerText = 'Reset field';
    let label = labelText;
    if (!label && input && input.id) {
        const associatedLabel = document.querySelector(`label[for="${input.id}"]`);
        if (associatedLabel) {
            label = associatedLabel.textContent.trim();
        }
    }
    btn.setAttribute('aria-label', `Clear ${label || 'Input'}`);
    parentElem.appendChild(btn);
    return btn;
}
function attachElement(parentElem, labelText) {
    if (parentElem.dataset[DataAttribs.READY] === 'true') {
        return;
    }
    const input = parentElem.querySelector(Selectors.INPUT);
    if (!input) {
        return;
    }
    input.addEventListener('keyup', onKeyUp);
    input.addEventListener('focus', onKeyUp);
    const btn = addClearBtn(parentElem, labelText, input);
    btn.addEventListener('click', onClearClick);
    parentElem.dataset[DataAttribs.READY] = 'true';
}
function attach() {
    document.querySelectorAll(Selectors.AUTO_ATTACH_INPUTS).forEach(element => attachElement(element));
}
function make(inputElement, opts) {
    opts = opts || {};
    inputElement.classList.add('fd-clearable-input__input');
    if (opts.isSearch) {
        inputElement.classList.add('fd-clearable-input__input-left-icon');
    }
    const parentElem = document.createElement('div');
    parentElem.classList.add('fd-clearable-input');
    parentElem.dataset[DataAttribs.MODAL] = Boolean(opts.isModal);
    parentElem.appendChild(inputElement);
    attachElement(parentElem, opts.label);
    return parentElem;
}
function extendLegacy(area, publicInterface) {
    window.Fandango = window.Fandango || {};
    const { Fandango } = window;
    if (!Fandango[area]) {
        Fandango[area] = publicInterface;
    }
}
document.addEventListener('DOMContentLoaded', attach);
module.exports = {
    make,
    attach
};
extendLegacy('clearableInput', module.exports);
export default module.exports;